import { Component, Inject } from '@angular/core';
import { PrescriptionsService } from "../service/prescriptions.service";
import { PrescriptionDataModel, PrescriptionViewModel, keyvaluepair } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
declare var prescriptionGrid: any;
declare var require: any;

@Component({
    selector: 'MentisSoft-Prescriptions',
    template: require('../Template/Prescriptions.template.html'),
    styles: [require('../Template/Prescriptions.css')]
})

export class PrescriptionsComponent {
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _prescriptionService: PrescriptionsService,
        private _titleService: Title, private router: Router) {
        prescriptionGrid = this;
    }

    loading = false;
    year = new Date();
    month = ("0" + (this.year.getMonth() + 1)).slice(-2)
    date: string = ("0" + this.year.getDate()).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();

    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };

    dataSource: PrescriptionDataModel[] = [];

    prescriptionFilter: PrescriptionDataModel = new PrescriptionDataModel();
    columns: any[] = [];

    doctorList: string[] = [];
    dateList: string[] = [];
    testList: string[] = [];
    bFiltersLoaded: boolean = false;
    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("Prescriptions ");
        this.LoadPrescriptions();
    }

    onChange(event) {
        this.LoadFilterReports();
    }

    LoadFilterReports() {
        if (this.dataSource != null) {
            let labFilters: keyvaluepair[] = [];

            for (var f in this.prescriptionFilter) {
                if (this.prescriptionFilter[f] != undefined && this.prescriptionFilter[f] != null && this.prescriptionFilter[f] != 'All') {
                    let kv: keyvaluepair = new keyvaluepair();
                    kv.key = f;
                    kv.value = this.prescriptionFilter[f];
                    labFilters.push(kv);
                }
            }

            this.buildGrid(this.getFilteredDataSource(labFilters));
        }
    }

    getFilteredData(ds: PrescriptionDataModel[], filter: keyvaluepair): PrescriptionDataModel[] {
        let dsFiltered: PrescriptionDataModel[] = [];
        if (filter != null && ds != null && ds.length > 0) {
            for (let d in ds) {
                if (filter.key == "DrugName") {
                    for (var d1 in ds[d].PrescriptionsSubData) {
                        for (var d2 in ds[d].PrescriptionsSubData[d1]) {
                            if (filter.key == d2) {
                                if (filter.value == ds[d].PrescriptionsSubData[d1][d2]) {
                                    dsFiltered.push(ds[d]);
                                }
                            }
                        }
                    }
                }
                else {
                    for (var d1 in ds[d]) {
                        if (filter.key == d1) {
                            if (filter.value == ds[d][d1]) {
                                dsFiltered.push(ds[d]);
                            }
                        }
                    }
                }
            }
        }
        return dsFiltered;
    }
    getFilteredDataSource(filter: keyvaluepair[]): PrescriptionDataModel[] {
        let ds: PrescriptionDataModel[] = this.dataSource;
        if (filter != null && filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                ds = this.getFilteredData(ds, filter[i]);
            }
        }
        return ds;
    }

    public buildGrid(data) {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdPrescriptions").data("kendoGrid");
            if (dgrid) {
                $('#grdPrescriptions').data().kendoGrid.destroy();
                $('#grdPrescriptions').empty();
            }
            jQuery('#grdPrescriptions').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,

                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },
                dataBinding: this.databinding,

                dataSource: {
                    data: data,
                    pageSize: data != null ? 10 : 0,
                    sort: [{
                        field: "ProfitCenter",
                        dir: "asc"
                    }, {
                        field: "Department",
                        dir: "asc"
                    }, {
                        field: "Modified",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdPrescriptions").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdPrescriptions").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            console.log("Error in build grid" + ex.message);
            this.handleError(ex);
        }
    }

    buildColumn(): void {

        this.columns = [
            {
                field: "VisitNo",
                title: " ",
                template: kendo.template("#=this.buildLabReportRow(PrescriptionDate,PrescriptionNo,PrescriptionsSubData,DoctorName)#").bind(this)
            }
        ];
    }

    private handleError(error: any) {

    }

    LoadPrescriptions() {
        this.loading = true;
        this._prescriptionService.getPrescriptions(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.dataSource = p.Prescriptions;

                    if (this.dataSource.length == 0) {
                    }
                    else {
                        this.dataSource = p.Prescriptions;
                        if (!this.bFiltersLoaded) {
                            this.buildFilters();
                        }
                        this.bFiltersLoaded = true;
                        this.buildGrid(this.dataSource);
                        this._SecurityService.errorMessage = "";
                    }
                }

                else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            }

            );
    }
    getDistinctDoctors() {
        this.doctorList = [];
        this.doctorList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.doctorList.indexOf(this.dataSource[i].DoctorName) == -1) {
                    this.doctorList.push(this.dataSource[i].DoctorName);
                }
            }
        }
    }
    getDistinctMedicine() {
        this.testList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                for (var j = 0; j < this.dataSource[i].PrescriptionsSubData.length; j++) {
                    if (this.testList.indexOf(this.dataSource[i].PrescriptionsSubData[j].DrugName) == -1) {
                        this.testList.push(this.dataSource[i].PrescriptionsSubData[j].DrugName);
                    }
                }
            }
        }


    }
    getDistinctDates() {
        this.dateList = [];
        this.dateList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dateList.indexOf(this.dataSource[i].PrescriptionDate) == -1) {
                    this.dateList.push(this.dataSource[i].PrescriptionDate);
                }
            }
        }
    }

    buildFilters() {
        this.getDistinctDoctors();
        this.getDistinctMedicine();
        this.getDistinctDates();
    }


    buildLabReportRow(PrescriptionDate: string, PrescriptionNo: string, PrescriptionSubsData: PrescriptionViewModel[], DoctorName: string): string {

        var instruction: string, ReqNo: string, TestCode: string;
        var row1 = "";
        var line1 = "<div class='resultstablewrap'> <div class='visit_wrap' > <div class='doctor_date'> <span> <i class='fa fa-calendar-check-o' aria- hidden='true' > </i>" + PrescriptionDate + " </span>";
        var line2 = " <span class='pull-right' ><strong>Dr.</strong>" + DoctorName + "</span ></div> ";

        var tableContent = "<table class='presTable'><tr><th style='width:40%;'>Medicine</th><th style='width:10%;'>Dosage</th><th style='width:20%;'>Usage</th><th style='width:30%;'>Notes</th></tr>";
        var tableEnd = "</table></div>";
        if (PrescriptionSubsData && PrescriptionSubsData.length > 0) {
            var row;
            for (var i = 0; i < PrescriptionSubsData.length; i++) {
                var r1 = "<tr><td><span>" + PrescriptionSubsData[i].DrugName + "</span ></td> ";
                var r2 = "<td><span> " + PrescriptionSubsData[i].Dosage + " </span ></td>";
                var r3 = "<td><span> " + PrescriptionSubsData[i].Usages + " </span ></td>";
                var r4 = "<td><span> " + PrescriptionSubsData[i].Frequency + " </span ></td></tr>";
                row = r1 + r2 + r3 + r4;
                row1 = row1.concat(row);
            }
        }
        return line1 + line2 + tableContent + row1 + tableEnd;
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdPrescriptions").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {

        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/prescriptions/Component/Prescriptions.Component.ts